export default "__VITE_ASSET__Djb6YUiG__"